/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-intake
 * crm-screener-intake
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * 
 * @export
 * @interface MissingInfoSendResult
 */
export interface MissingInfoSendResult {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    idempotency_key: string;
    /**
     * Outcome of the returned logical request; pending is accepted work and sending is a started delivery, and neither is evidence of delivery
     */
    send_status: MissingInfoSendResultSendStatusEnum;
    /**
     * 
     */
    final_message_text: string;
    /**
     * 
     */
    connector_message_id?: string;
    /**
     * 
     */
    sent_at?: Date;
    /**
     * 
     */
    failure_type?: string;
    /**
     * 
     */
    date_created: Date;
    /**
     * Current follow-up status, independent of the historical attempt returned on replay
     */
    case_status: MissingInfoSendResultCaseStatusEnum;
}


/**
 * @export
 */
export const MissingInfoSendResultSendStatusEnum = {
    Pending: 'pending',
    Sending: 'sending',
    Succeeded: 'succeeded',
    Failed: 'failed',
    Unknown: 'unknown',
} as const;
export type MissingInfoSendResultSendStatusEnum = typeof MissingInfoSendResultSendStatusEnum[keyof typeof MissingInfoSendResultSendStatusEnum];

/**
 * @export
 */
export const MissingInfoSendResultCaseStatusEnum = {
    Draft: 'draft',
    Sending: 'sending',
    WaitingForResponse: 'waiting_for_response',
    SendFailed: 'send_failed',
    SendUnknown: 'send_unknown',
} as const;
export type MissingInfoSendResultCaseStatusEnum = typeof MissingInfoSendResultCaseStatusEnum[keyof typeof MissingInfoSendResultCaseStatusEnum];


/**
 * Check if a given object implements the MissingInfoSendResult interface.
 */
export function instanceOfMissingInfoSendResult(value: object): value is MissingInfoSendResult {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('idempotency_key' in value) || value['idempotency_key'] === undefined) return false;
    if (!('send_status' in value) || value['send_status'] === undefined) return false;
    if (!('final_message_text' in value) || value['final_message_text'] === undefined) return false;
    if (!('date_created' in value) || value['date_created'] === undefined) return false;
    if (!('case_status' in value) || value['case_status'] === undefined) return false;
    return true;
}

export function MissingInfoSendResultFromJSON(json: any): MissingInfoSendResult {
    return MissingInfoSendResultFromJSONTyped(json, false);
}

export function MissingInfoSendResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): MissingInfoSendResult {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'idempotency_key': json['idempotency_key'],
        'send_status': json['send_status'],
        'final_message_text': json['final_message_text'],
        'connector_message_id': json['connector_message_id'] == null ? undefined : json['connector_message_id'],
        'sent_at': json['sent_at'] == null ? undefined : (parseDateTime(json['sent_at'])),
        'failure_type': json['failure_type'] == null ? undefined : json['failure_type'],
        'date_created': (json['date_created'] == null ? json['date_created'] : parseDateTime(json['date_created'])),
        'case_status': json['case_status'],
    };
}

export function MissingInfoSendResultToJSON(json: any): MissingInfoSendResult {
    return MissingInfoSendResultToJSONTyped(json, false);
}

export function MissingInfoSendResultToJSONTyped(value?: MissingInfoSendResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'idempotency_key': value['idempotency_key'],
        'send_status': value['send_status'],
        'final_message_text': value['final_message_text'],
        'connector_message_id': value['connector_message_id'],
        'sent_at': value['sent_at'] == null ? value['sent_at'] : serializeDateTime(value['sent_at']),
        'failure_type': value['failure_type'],
        'date_created': value['date_created'] == null ? value['date_created'] : serializeDateTime(value['date_created']),
        'case_status': value['case_status'],
    };
}

